(function () {

  'use strict';

  function pxWorkflowProperties(
    // AngularJS dependencies
    $filter, $location, $q, $rootScope, $timeout,
    // 3rd party dependencies
    toastr, uuid,
    // Proprietary dependencies
    CopilotService, DataSourceRecord, DataSourceService, MetadataCustomFieldRequest, MetadataCustomFieldType, MetadataCustomFieldValidationRequest,
    MetadataCustomFieldValidationType, MetadataProfileRequest, MetadataProfileService, RegexModel, WorkflowFormModel,
    WorkflowService, DATE_VARIABLES, MFP_VARIABLES, PHONE_VARIABLES, SEND_TO_USER) {
    return {
      restrict: 'E',
      scope: {
        me: '=',
        tenant: '=',
        workflowData: '=',
        behavior: '=',
        channel: '='
      },
      templateUrl: 'app/components/settings/workflows/workflowProperties/workflowProperties.template.html',
      link: function (scope, element, attrs) {

        scope.savingWorkflow = false;

        scope.workflowFormModel = scope.workflowData ? scope.workflowData.formModel : new WorkflowFormModel();
        const originalWorkflowFormModel = angular.copy(scope.workflowFormModel);

        scope.workflowFormModel.metadataProfile.dataSourceIdsToRemove = [];

        scope.workflowFormModel.metadataProfile.metadataFields.forEach((metadataField) => {
          metadataField.oldName = metadataField.name;
          if (metadataField.type === MetadataCustomFieldType.Lookup) {
            DataSourceService.getDataSourceRecords(metadataField.linkRecords)
              .then(function (dataSourceRecordResponses) {
                metadataField.availableValues = dataSourceRecordResponses.map(dataSourceRecordResponse =>
                  new DataSourceRecord().fromDataSourceRecordResponse(dataSourceRecordResponse));
              });
          } else {
            metadataField.availableValues = [];
          }
        });

        scope.isPrimaryButtonDisabled = function () {
          if (scope.savingWorkflow || scope.workflowForm.$invalid || (scope.workflowFormModel.availability === 'GROUPS' && !scope.workflowFormModel.groups.length)) {
            return true;
          }
          switch (scope.workflowFormModel.destination) {
            case 'SEND_TO_EMAIL':
              return scope.emailFormModel?.emailSetupIsInvalid ?? true;
            case 'SEND_TO_SHAREPOINT':
              return !scope.workflowFormModel.SEND_TO_SHAREPOINT.destinationProfile;
            case 'SEND_TO_ONEDRIVE':
              return !scope.workflowFormModel.SEND_TO_ONEDRIVE.destinationProfile;
            case 'SEND_TO_CONNECTOR':
              return !scope.workflowFormModel.SEND_TO_CONNECTOR.destinationProfile;
          }
          return false;
        };

        scope.onPrimaryButtonClick = async function () {
          let success;
          if (scope.behavior === 'create') {
            // Create a new workflow
            if (scope.workflowFormModel.metadataProfile.metadataFields.length) {
              // Create a new metadata profile
              scope.workflowFormModel.metadataProfile.displayName = 'Metadata_' + uuid.v4();
              await createMetadataProfile();
              scope.workflowFormModel.INTERACTIVE.metadataProfileId = scope.workflowFormModel.metadataProfile.id;
            }
            success = await createWorkflow();
          } else {
            // Update an existing workflow
            let metadataProfileIdToDelete;
            if (scope.workflowFormModel.INTERACTIVE.metadataProfileId) {
              if (scope.workflowFormModel.metadataProfile.metadataFields.length) {
                // Update the existing metadata profile
                await updateMetadataProfile();
              } else {
                // Delete the existing metadata profile
                metadataProfileIdToDelete = scope.workflowFormModel.metadataProfile.id;
                scope.workflowFormModel.metadataProfile.id = null;
                scope.workflowFormModel.INTERACTIVE.metadataProfileId = null;
              }
            } else {
              if (scope.workflowFormModel.metadataProfile.metadataFields.length) {
                // Create a new metadata profile
                scope.workflowFormModel.metadataProfile.displayName = 'Metadata_' + uuid.v4();
                await createMetadataProfile();
                scope.workflowFormModel.INTERACTIVE.metadataProfileId = scope.workflowFormModel.metadataProfile.id;
              }
            }
            if (metadataProfileIdToDelete) {
              success = await updateWorkflow();
              await deleteMetadataProfile(metadataProfileIdToDelete);
            } else {
              success = await updateWorkflow();
            }
          }

          // Delete data source of metadata fields that were previously of type Lookup
          for (const metadataField of scope.workflowFormModel.metadataProfile.metadataFields) {
            if (metadataField.dataSource?.id && metadataField.type !== MetadataCustomFieldType.Lookup) {
              await DataSourceService.deleteDataSource(metadataField.dataSource.id);
              metadataField.availableValues = [];
              metadataField.dataSource = undefined;
            }
          }

          // Delete data source of metadata fields to be deleted
          for (const dataSourceIdToRemove of scope.workflowFormModel.metadataProfile.dataSourceIdsToRemove) {
            await DataSourceService.deleteDataSource(dataSourceIdToRemove);
          }
          scope.workflowFormModel.metadataProfile.dataSourceIdsToRemove = [];

          return success;
        };

        scope.cancelAndExit = function () {
          deleteDataSourceOfNewMetadataFields();
          if (scope.behavior === 'edit') {
            $location.path('/settings/').search({ settingsSection: 'workflows' });
          }
        };

        scope.$watch(scope.isPrimaryButtonDisabled, function (newValue, oldValue) {
          if (scope.channel?.onValidityChange) {
            scope.channel.onValidityChange(!newValue);
          }
        });

        scope.$watch('scope.channel', function (newValue, oldValue) {
          if (scope.channel) {
            scope.channel.createWorkflow = async function () {
              if (scope.isPrimaryButtonDisabled()) {
                return false;
              }
              return await scope.onPrimaryButtonClick();
            };
            scope.channel.cancelWorkflow = function () {
              scope.cancelAndExit();
            };
          }
        });

        function convertMetadataFieldToMetadataCustomFieldRequest(metadataField) {
          const metadataCustomFieldRequest = new MetadataCustomFieldRequest();

          metadataCustomFieldRequest.id = metadataField.id;
          metadataCustomFieldRequest.name = metadataField.name;
          metadataCustomFieldRequest.displayName = metadataField.label;
          metadataCustomFieldRequest.required = metadataField.required;
          metadataCustomFieldRequest.defaultValue = metadataField.defaultValue || undefined;

          if (metadataField.type === MetadataCustomFieldType.Text) {
            if (metadataField.validationType === MetadataCustomFieldType.Date) {
              metadataCustomFieldRequest.type = MetadataCustomFieldType.Date;
              metadataCustomFieldRequest.format = metadataField.dateFormat;
            } else {
              metadataCustomFieldRequest.type = metadataField.type;
              if (metadataField.validationType) {
                const pattern = metadataField.validationType === MetadataCustomFieldValidationType.Regex ? metadataField.regularExpression : undefined;
                const maxDigits = metadataField.validationType === MetadataCustomFieldValidationType.Numeric ? metadataField.decimals : undefined;
                metadataCustomFieldRequest.validation = new MetadataCustomFieldValidationRequest(metadataField.validationType, pattern, maxDigits);
              }
            }
          } else if (metadataField.type === MetadataCustomFieldType.Lookup) {
            metadataCustomFieldRequest.type = metadataField.type;
            metadataCustomFieldRequest.dataSourceId = metadataField.dataSource?.id;
          }

          return metadataCustomFieldRequest;
        }

        function convertMetadataProfileToMetadataProfileRequest(metadataProfile) {
          const metadataCustomFieldRequests = metadataProfile.metadataFields.map(
            metadataField => convertMetadataFieldToMetadataCustomFieldRequest(metadataField)
          );
          return new MetadataProfileRequest(metadataProfile.displayName, metadataCustomFieldRequests);
        }

        function createMetadataProfile() {
          const metadataProfile = scope.workflowFormModel.metadataProfile;
          const metadataProfileRequest = convertMetadataProfileToMetadataProfileRequest(metadataProfile);
          return MetadataProfileService.createMetadataProfile(metadataProfileRequest)
            .then(function (metadataProfileResponse) {
              scope.workflowFormModel.metadataProfile.id = metadataProfileResponse.id;
              return true;
            })
            .catch(function () {
              return false;
            });
        }

        function updateMetadataProfile() {
          const metadataProfile = scope.workflowFormModel.metadataProfile;
          const metadataProfileRequest = convertMetadataProfileToMetadataProfileRequest(metadataProfile);
          return MetadataProfileService.updateMetadataProfile(metadataProfile.id, metadataProfileRequest)
            .then(function (metadataProfileResponse) {
              return true;
            })
            .catch(function () {
              return false;
            });
        }

        function deleteMetadataProfile(metadataProfileId) {
          if (!metadataProfileId) {
            metadataProfileId = scope.workflowFormModel.metadataProfile.id;
          }
          return MetadataProfileService.deleteMetadataProfile(metadataProfileId)
            .then(function () {
              scope.workflowFormModel.metadataProfile.id = null;
              return true;
            })
            .catch(function () {
              return false;
            });
        }

        function deleteDataSourceOfNewMetadataFields() {
          for (const metadataField of scope.workflowFormModel.metadataProfile.metadataFields) {
            if (metadataField.isNew && metadataField.dataSource?.id) {
              DataSourceService.deleteDataSource(metadataField.dataSource.id);
            }
          }
        }

        function createWorkflow() {
          scope.savingWorkflow = true;
          return WorkflowService.createWorkflow(scope.workflowFormModel)
            .then(function (response) {
              scope.savingWorkflow = false;
              toastr.success($filter('translate')('WorkflowCreatedSuccessfully'));
              return true;
            })
            .catch(function (response) {
              scope.savingWorkflow = false;
              handleSaveError(response);
              return false;
            });
        }

        function updateWorkflow() {
          scope.savingWorkflow = true;
          return scope.workflowData.updateWorkflow(originalWorkflowFormModel)
            .then(function (response) {
              scope.savingWorkflow = false;
              if (response && response.data) {
                toastr.success($filter('translate')('ChangesSaved'));
              }
              $location.path('/settings/').search({ settingsSection: 'workflows' });
              return true;
            })
            .catch(function (response) {
              scope.savingWorkflow = false;
              handleSaveError(response);
              return false;
            });
        }

        function handleSaveError(response) {
          if (response.status === 409) {
            if (response.data.errorCode === 'UNVERIFIED_RECIPIENTS') {
              scope.emailFormModel.setUnVerifiedEmailRecipients(response.data.parameters);
              response.data.manualLink = 'https://docshield.tungstenautomation.com/Printix/en_US/help/admin/Printix_admin/t_how_to_create_a_workflow_for_email.html';
              // We return here so we don't show an error dialogue (via broadcast) when the error is already reported in the form ui.
              return;
            }
            $rootScope.$broadcast('REQUEST_ERROR_HELP', { error: response });
          } else {
            toastr.error($filter('translate')('Error'));
          }
        }

        /**************************************************************************************************************/

        function initializeWorkflowForm() {
          scope.workflowVariables = new WorkflowVariables();

          scope.fileNameShorthands = {
            DATE: dateExamples(scope.workflowVariables, DATE_VARIABLES),
            FILE_NAME_CONTEXT: scope.workflowFormModel.source === 'PHONE' ? PHONE_VARIABLES : MFP_VARIABLES,
            MFP_VARIABLES,
            PHONE_VARIABLES
          };

          $timeout(() => { // Wait for the form to be initialized
            scope.fileNameFormModel = new FileNameConstructor(scope.workflowVariables, scope.workflowFormModel.metadataProfile.metadataFields);
            scope.fileNameFormModel.initialize(scope.workflowFormModel.fileName);

            scope.filePathFormModel_ONEDRIVE = new FilePathConstructor('ONEDRIVE', scope.workflowVariables, scope.workflowFormModel.metadataProfile.metadataFields);
            scope.filePathFormModel_ONEDRIVE.initialize(scope.workflowFormModel.SEND_TO_ONEDRIVE.filepathConfiguration.template);

            scope.filePathFormModel_SHAREPOINT = new FilePathConstructor('SHAREPOINT', scope.workflowVariables, scope.workflowFormModel.metadataProfile.metadataFields);
            scope.filePathFormModel_SHAREPOINT.initialize(scope.workflowFormModel.SEND_TO_SHAREPOINT.filepathConfiguration.template);

            scope.emailFormModel = new EmailConstructor();
            scope.emailFormModel.initEmailModel();
          }, 1000);
        }

        function WorkflowVariables() {
          this.date = new Date().toISOString();
          this.variables = {
            USER_NAME: scope.me.info._embedded.user.name.split(',')[0].replace(' ', ''),
            WORKFLOW_NAME: scope.workflowFormModel.name || '{workflow_name}',
            PRINTER_ID: '{printer_id}',
            PRINTER_NAME: '{printer_name}',
            PRINTER_LOCATION: '{printer_location}',
            // DOCUMENT_NAME: '{document_name}',
            MM_DD_YYYY: $filter('date')(this.date, 'MM-dd-yyyy'),
            MM_DD_YYYY_TIME: $filter('date')(this.date, 'MM-dd-yyyy_HH-mm-ss'),
            DD_MM_YYYY: $filter('date')(this.date, 'dd-MM-yyyy'),
            DD_MM_YYYY_TIME: $filter('date')(this.date, 'dd-MM-yyyy_HH-mm-ss'),
            YYYY_MM_DD: $filter('date')(this.date, 'yyyy-MM-dd'),
            YYYY_MM_DD_TIME: $filter('date')(this.date, 'yyyy-MM-dd_HH-mm-ss')
          };
        }

        function dateExamples(workflowVariables, dateVariables) {
          dateVariables.forEach((dateVariable) => {
            dateVariable.example = workflowVariables.variables[dateVariable.id];
          });
          return dateVariables;
        }

        function FileNameConstructor(workflowVariables, metadataFields) {
          this.workflowVariables = workflowVariables.variables;
          this.metadataFields = metadataFields;
          this.fileName = ''; // The file name input model.
          this.example = '';  // The file name example with variables replaced by their values.
          this.illegalVariables = [];
          this.illegalCharacters = [];
          this.illegalCharactersRegExp = new RegexModel().badNameString_variables().regex;

          this.initialize = (fileName) => {
            this.fileName = fileName ?? '';
            this.handleFileNameChange();
          };

          this.handleWorkflowNameChange = () => {
            this.workflowVariables.WORKFLOW_NAME = scope.workflowFormModel.name || '{workflow_name}';
            this.updateFileNameExample();
          };

          this.handleFileNameChange = () => {
            if (!scope.workflowForm.file_name || this.validateFileName()) {
              this.updateFileName();
              this.updateFileNameExample();
            }
          };

          this.validateFileName = () => {
            const inputElement = scope.workflowForm.file_name;

            if (inputElement) {
              inputElement.$setValidity('required', !!this.fileName);

              this.collectIllegalCharacters();
              inputElement.$setValidity('pxIllegalCharacters', !this.illegalCharacters.length);

              this.collectIllegalVariables();
              inputElement.$setValidity('pxIllegalVariables', !this.illegalVariables.length);

              return inputElement.$valid;
            }

            return false;
          };

          this.collectIllegalCharacters = () => {
            this.illegalCharacters = this.fileName?.match(this.illegalCharactersRegExp) ?? [];
          };

          this.collectIllegalVariables = () => {
            let illegalVariables;
            if (this.fileName) {
              // TODO: Consider using a whitelist instead of a blacklist.
              const BLACKLISTED_VARIABLE_FOR_MFP = [
                '{document_name}', '{DOCUMENT_NAME}'
              ];
              const BLACKLISTED_VARIABLE_FOR_PHONE = [
                '{document_name}', '{printer_id}', '{printer_location}', '{printer_name}',
                '{DOCUMENT_NAME}', '{PRINTER_ID}', '{PRINTER_LOCATION}', '{PRINTER_NAME}'
              ];
              switch (scope.workflowFormModel.source) {
                case 'MFP':
                  illegalVariables = BLACKLISTED_VARIABLE_FOR_MFP.filter(variable => this.fileName.indexOf(variable) !== -1);
                  break;
                case 'PHONE':
                  illegalVariables = BLACKLISTED_VARIABLE_FOR_PHONE.filter(variable => this.fileName.indexOf(variable) !== -1);
                  break;
              }
            }
            this.illegalVariables = illegalVariables ?? [];
          };

          this.updateFileName = () => {
            scope.workflowFormModel.SEND_TO_EMAIL.filenameConfiguration.template = this.fileName;
            scope.workflowFormModel.SEND_TO_ONEDRIVE.filenameConfiguration.template = this.fileName;
            scope.workflowFormModel.SEND_TO_SHAREPOINT.filenameConfiguration.template = this.fileName;
            scope.workflowFormModel.SEND_TO_CONNECTOR.filenameConfiguration.template = this.fileName;
          };

          this.updateFileNameExample = () => {
            let fileNameExample = this.fileName;

            // Replace variables and dates with their values.
            for (const key in this.workflowVariables) {
              fileNameExample = fileNameExample.replaceAll(`{${key}}`, this.workflowVariables[key]);
            }

            // Replace metadata UUIDs with their names.
            if (this.metadataFields?.length) {
              this.metadataFields.forEach(metadata => {
                const from = '{' + metadata.id + (metadata.type === 'LOOKUP' ? ',0' : '') + '}';
                const to = '{' + metadata.name + '}';
                fileNameExample = fileNameExample.replaceAll(from, to);
              });
            }

            // Append file extension based on file type.
            switch (scope.workflowFormModel.fileType) {
              case 'GENERATE_SEARCHABLE_PDF':
                fileNameExample += '.pdf';
                break;
              case 'GENERATE_DOCX':
                fileNameExample += '.docx';
                break;
            }

            this.example = fileNameExample;
          };
        }

        function FilePathConstructor(type, workflowVariables, metadataFields) {
          this.destinationType = type;
          this.workflowVariables = workflowVariables.variables;
          this.metadataFields = metadataFields;
          this.filePath = ''; // The file path input model.
          this.example = '';  // The file path example with variables replaced by their values.
          this.illegalVariables = [];
          this.illegalCharacters = [];
          this.illegalCharactersRegExp = new RegexModel().badPathString_variables().regex;

          this.initialize = (filePath) => {
            this.filePath = filePath ?? '';
            this.handleFilePathChange();
          };

          this.handleWorkflowNameChange = () => {
            this.workflowVariables.WORKFLOW_NAME = scope.workflowFormModel.name || '{workflow_name}';
            this.updateFilePathExample();
          };

          this.handleFilePathChange = () => {
            if (scope.workflowForm['filepath_' + this.destinationType]) {
              if (this.validateFilePath()) {
                this.updateFilePath();
                this.updateFilePathExample();
              }
            }
          };

          this.validateFilePath = () => {
            const inputElement = scope.workflowForm['filepath_' + this.destinationType];

            if (inputElement) {
              this.collectIllegalCharacters();
              inputElement.$setValidity('pxIllegalCharacters', !this.illegalCharacters.length);

              this.collectIllegalVariables();
              inputElement.$setValidity('pxIllegalVariables', !this.illegalVariables.length);

              return inputElement.$valid;
            }

            return false;
          };

          this.collectIllegalCharacters = () => {
            this.illegalCharacters = this.filePath?.match(this.illegalCharactersRegExp) ?? [];
          };

          this.collectIllegalVariables = () => {
            let illegalVariables;
            if (this.filePath) {
              // TODO: Consider using a whitelist instead of a blacklist.
              const BLACKLISTED_VARIABLE_FOR_MFP = [
                '{document_name}', '{DOCUMENT_NAME}'
              ];
              const BLACKLISTED_VARIABLE_FOR_PHONE = [
                '{document_name}', '{printer_id}', '{printer_location}', '{printer_name}',
                '{DOCUMENT_NAME}', '{PRINTER_ID}', '{PRINTER_LOCATION}', '{PRINTER_NAME}'
              ];
              switch (scope.workflowFormModel.source) {
                case 'MFP':
                  illegalVariables = BLACKLISTED_VARIABLE_FOR_MFP.filter(variable => this.filePath.indexOf(variable) !== -1);
                  break;
                case 'PHONE':
                  illegalVariables = BLACKLISTED_VARIABLE_FOR_PHONE.filter(variable => this.filePath.indexOf(variable) !== -1);
                  break;
              }
            }
            this.illegalVariables = illegalVariables ?? [];
          };

          this.updateFilePath = () => {
            const formattedFilePath = formatFilePath(this.filePath);
            scope.workflowFormModel.SEND_TO_ONEDRIVE.filepathConfiguration.template = formattedFilePath;
            scope.workflowFormModel.SEND_TO_SHAREPOINT.filepathConfiguration.template = formattedFilePath;
          };

          this.updateFilePathExample = () => {
            let filePathExample = formatFilePath(this.filePath);

            // Replace variables and dates with their values.
            for (const key in this.workflowVariables) {
              filePathExample = filePathExample.replaceAll(`{${key}}`, this.workflowVariables[key]);
            }

            // Replace metadata UUIDs with their names.
            if (this.metadataFields?.length) {
              this.metadataFields.forEach(metadata => {
                const from = '{' + metadata.id + (metadata.type === 'LOOKUP' ? ',0' : '') + '}';
                const to = '{' + metadata.name + '}';
                filePathExample = filePathExample.replaceAll(from, to);
              });
            }

            this.example = filePathExample;
          };

          function formatFilePath(filePath) {
            filePath = filePath ?? '';

            // Add leading slash if not present.
            if (filePath.length === 0 || filePath.charAt(0) !== '/') {
              filePath = '/' + filePath;
            }

            // Add trailing slash if not present.
            if (filePath.length > 1 && filePath.charAt(filePath.length - 1) !== '/') {
              filePath = filePath + '/';
            }

            // Do not allow multiple slashes.
            filePath = filePath.replace(/\/\/+/g, '/');

            return filePath;
          }
        }

        function EmailConstructor() {
          this.emailString = { to: '', cc: '', bcc: '' };
          this.emailsAsArrays = { to: [], cc: [], bcc: [] };
          this.invalid = { to: [], cc: [], bcc: [] };
          this.unVerifiedEmailDomain = { to: [], cc: [], bcc: [] };
          this.show = { to: true, cc: false, bcc: false };
          this.toPlaceholder = 'EnterEmail';
          this.sendToUser = SEND_TO_USER;
          this.sendingToUser = false;
          this.emailSetupIsInvalid = false;
          this.subject = scope.workflowFormModel.SEND_TO_EMAIL.subject ?? '';
          this.subjectValid = true;
          this.splitEmails = new RegexModel().splitEmailString;
          this.emailRegexParams = new RegexModel().emailRegexParams;
          this.isolateShorthand = new RegexModel().isolateShorthand;
          this.captureThisOrThat = new RegexModel().captureThisOrThat;
          this.unVerifiedEmailRecipients = [];
          this.hasIllegalChars = [];
          this.illegalCharRegexCheck = new RegexModel().badEmailString_variables().regex;
          this.badSubjectCheck = new RegexModel().badNameString_variables().regex;

          this.initEmailModel = () => {
            this.mapToViewModel();
            $timeout(() => {
              this.checkForSendToScanner();
              this.convertToString();
              this.setSubject();
            });
          };

          this.checkForSendToScanner = () => {
            for (const key in scope.workflowFormModel.SEND_TO_EMAIL.scanner) {
              if (scope.workflowFormModel.SEND_TO_EMAIL.scanner[key]) {
                this.emailsAsArrays[key].unshift('{user_email}');
                this.sendingToUser = true;
                this.setselectSendToScanner(key);
                break;
              }
            }
            if (!this.sendingToUser) {
              this.unselectSendToScanner();
            }
          };

          this.setselectSendToScanner = (key) => {
            $rootScope.$broadcast('SET_SELECTED', {
              identifier: 'SEND_TO_USER',
              item: this.sendToUser.find(item => item.id === key)
            });
          };

          this.unselectSendToScanner = () => {
            $rootScope.$broadcast('RESET_UI_SELECT', 'SEND_TO_USER');
          };

          this.mapToViewModel = () => {
            Object.keys(this.emailsAsArrays).forEach(key => {
              this.emailsAsArrays[key] = angular.copy(scope.workflowFormModel.SEND_TO_EMAIL[key]);
            });
          };

          this.toggleUserEmail = (item) => {
            const targets = Object.keys(this.emailsAsArrays);
            targets.forEach(target => {
              if (target !== item.id) {
                scope.workflowFormModel.SEND_TO_EMAIL.scanner[target] = false;
                const userEmailIndex = this.emailsAsArrays[target].indexOf('{user_email}');
                if (userEmailIndex > -1) {
                  this.emailsAsArrays[target].splice(userEmailIndex, 1);
                }
              } else {
                scope.workflowFormModel.SEND_TO_EMAIL.scanner[target] = true;
                const userEmailIndex = this.emailsAsArrays[target].indexOf('{user_email}');
                if (userEmailIndex <= -1) {
                  this.emailsAsArrays[target].unshift('{user_email}');
                }
              }
              this.mapToDataModel(target);
            });
            this.convertToString();
            this.show[item.id] = true;
          };

          this.convertToString = () => {
            const targets = Object.keys(this.emailsAsArrays);
            targets.forEach((target) => {
              this.emailString[target] = this.emailsAsArrays[target].join(', ');
              if (this.emailString[target].length > 0) {
                this.show[target] = true;
                this.appendTrailingComma(target);
              }
            });
          };

          this.appendTrailingComma = (target) => {
            // add trailing comma to string if not present
            if (this.emailString[target].length > 0 && this.emailString[target].charAt(this.emailString[target.length - 1]) !== ',') {
              this.emailString[target] += ',';
            }
            // do not allow multiple commas in a row
            this.emailString[target] = this.emailString[target].replace(/,,*/g, ',');
            // if last character is a comma, remove it and length string is exactly 1 then remove it
            if (this.emailString[target].length === 1 && this.emailString[target].charAt(this.emailString[target.length - 1]) === ',') {
              this.emailString[target] = '';
            }
          };

          this.update = (target) => {
            this.convertToArray(target);
            this.appendTrailingComma(target);
          };

          this.illegalCharacterCheck = (target) => {
            this.hasIllegalChars = this.emailString[target]?.match(this.illegalCharRegexCheck);
            if (this.hasIllegalChars?.length) {
              scope.workflowForm[`email_${target}`].$invalid = true;
              scope.workflowForm.$invalid = true;
            }
          };

          this.convertToArray = (target) => {
            if (this.emailString[target]) {
              this.emailsAsArrays[target] = this.emailString[target].split(this.splitEmails()).filter((e) => {
                return e.length > 0;
              });
            } else {
              this.emailsAsArrays[target] = [];
            }
            this.validateEmails(target);
          };

          this.validateEmails = (target) => {
            const hasInvalid = this.emailsAsArrays[target].some((email) => !this.emailRegexParams().test(email));
            if (hasInvalid) {
              this.invalid[target] = this.emailsAsArrays[target].filter((email) => !this.emailRegexParams().test(email));
            } else {
              this.invalid[target] = [];
            }
            this.mapToDataModel(target);
          };

          this.mapToDataModel = (target) => {
            scope.workflowFormModel.SEND_TO_EMAIL[target] = this.emailsAsArrays[target].filter(email => email !== '{user_email}');
            const sendToScanner = this.emailsAsArrays[target].some(email => email === '{user_email}');
            if (sendToScanner) {
              scope.workflowFormModel.SEND_TO_EMAIL.scanner[target] = true;
              this.setselectSendToScanner(target);
            } else {
              scope.workflowFormModel.SEND_TO_EMAIL.scanner[target] = false;
            }
            this.confirmEmailSetup();
          };

          this.confirmEmailSetup = () => {
            this.sendingToUser = Object.keys(scope.workflowFormModel.SEND_TO_EMAIL.scanner).some(key => scope.workflowFormModel.SEND_TO_EMAIL.scanner[key] === true);
            const hasEmails = Object.keys(this.emailsAsArrays).some(key => this.emailsAsArrays[key].length > 0);
            const hasInvalid = Object.keys(this.invalid).some(key => this.invalid[key].length > 0);
            const hasUnVerifiedDomain = Object.keys(this.unVerifiedEmailDomain).some(key => this.unVerifiedEmailDomain[key].length > 0);
            if (this.sendingToUser) {
              if (hasInvalid || hasUnVerifiedDomain) {
                this.emailSetupIsInvalid = true;
              } else {
                this.emailSetupIsInvalid = false;
              }
            } else {
              this.unselectSendToScanner();
              if (hasEmails) {
                if (hasInvalid || hasUnVerifiedDomain) {
                  this.emailSetupIsInvalid = true;
                } else {
                  this.emailSetupIsInvalid = false;
                }
              } else {
                this.emailSetupIsInvalid = true;
              }
            }
            if (this.emailsAsArrays.to.length < 1 || Object.keys(this.invalid.to).some(key => this.invalid.to.length > 0)) {
              this.emailSetupIsInvalid = true;
            }
          };

          this.setSubject = () => {
            if (this.subject && this.badSubjectCheck.test(this.subject)) {
              scope.workflowForm.email_subject.$invalid = true;
              scope.workflowForm.$invalid = true;
            } else {
              scope.workflowFormModel.SEND_TO_EMAIL.subject = this.subject;
            }
          };

          this.setUnVerifiedEmailRecipients = (recipients)  => {
            this.unVerifiedEmailRecipients = recipients;
            this.findUnVerifiedEmailRecipients();
          };

          this.findUnVerifiedEmailRecipients = () => {
            for (const key in this.emailString) {
              this.unVerifiedEmailRecipients.forEach(recipient => {
                if (this.emailsAsArrays[key].includes(recipient)) {
                  if (!this.unVerifiedEmailDomain[key].includes(recipient)) {
                    this.unVerifiedEmailDomain[key].push(recipient);
                  }
                } else {
                  if (this.unVerifiedEmailDomain[key].includes(recipient)) {
                    this.unVerifiedEmailDomain[key].shift(recipient);
                  }
                }
              });
              this.mapToDataModel(key);
            }
          };
        }

        /**************************************************************************************************************/

        initializeWorkflowForm();

        // Copilot
        (function () {
          const copilotRequestedName = CopilotService.useWorkflowName();
          if (copilotRequestedName) {
            scope.workflowFormModel.name = copilotRequestedName;
          }
          scope.copilotChatOpen = CopilotService.state.chatOpen;
          scope.$watch(function () {
            return CopilotService.state.chatOpen;
          }, function () {
            scope.copilotChatOpen = CopilotService.state.chatOpen;
          });
        })();

      }
    };
  }

  pxWorkflowProperties.$inject = [
    // AngularJS dependencies
    '$filter', '$location', '$q', '$rootScope', '$timeout',
    // 3rd party dependencies
    'toastr', 'uuid',
    // Proprietary dependencies
    'CopilotService', 'DataSourceRecord', 'DataSourceService', 'MetadataCustomFieldRequest', 'MetadataCustomFieldType', 'MetadataCustomFieldValidationRequest',
    'MetadataCustomFieldValidationType', 'MetadataProfileRequest', 'MetadataProfileService', 'RegexModel', 'WorkflowFormModel',
    'WorkflowService', 'DATE_VARIABLES', 'MFP_VARIABLES', 'PHONE_VARIABLES', 'SEND_TO_USER'
  ];

  angular
    .module('printix-admin')
    .directive('pxWorkflowProperties', pxWorkflowProperties)
    .constant('DESTINATIONS', [
      { id: 'SEND_TO_EMAIL', name: 'Email' },
      { id: 'SEND_TO_ONEDRIVE', name: 'Microsoft OneDrive' },
      { id: 'SEND_TO_SHAREPOINT', name: 'Microsoft SharePoint Online' },
      { id: 'SEND_TO_CONNECTOR', name: 'Connector' }
    ])
    .constant('PAPER_SIZE', [
      { id: 'AUTO', name: 'SelectAutomatically' },
      { id: 'A3', name: 'A3' },
      { id: 'A4', name: 'A4' },
      { id: 'A5', name: 'A5' },
      { id: 'A6', name: 'A6' },
      { id: 'B4', name: 'B4' },
      { id: 'B5', name: 'B5' },
      { id: 'LEDGER', name: 'Ledger' },
      { id: 'LEGAL', name: 'Legal' },
      { id: 'LETTER', name: 'Letter' },
      // {id: 'FOLIO', name: 'Folio'},
      { id: 'STATEMENT', name: 'Statement' },
      { id: 'EXECUTIVE', name: 'Executive' }
    ])
    .constant('ORIENTATION', [
      { id: 'AUTO', name: 'SelectAutomatically' },
      { id: 'LANDSCAPE', name: 'Landscape' },
      { id: 'PORTRAIT', name: 'Portrait' }
    ])
    .constant('COLOR', [
      { id: 'GREY', name: 'Grey' },
      { id: 'COLOR', name: 'Color' },
      { id: 'BLACK_AND_WHITE', name: 'BlackAndWhite' }
    ])
    .constant('RESOLUTION', [
      { id: 200, name: '200' },
      { id: 300, name: '300' },
      { id: 400, name: '400' },
      { id: 600, name: '600' }
    ])
    .constant('PDF_IMAGE_QUALITY', [
      { id: 'MIN', name: 'Low' },
      { id: 'MEDIUM', name: 'Medium' },
      { id: 'MAX', name: 'High' }
    ])
    .constant('IMAGE_QUALITY', [
      { id: 'MIN', name: 'Low' },
      { id: 'MEDIUM', name: 'Medium' },
      { id: 'MAX', name: 'High' }
    ])
    .constant('PDF_COMPATIBILITY', [
      { id: 'PDF_2_0', name: 'PDF 2.0' },
      { id: 'PDF_1_7', name: 'PDF 1.7' },
      { id: 'PDF_1_6', name: 'PDF 1.6' },
      { id: 'PDF_1_5', name: 'PDF 1.5' },
      { id: 'PDF_1_4', name: 'PDF 1.4' },
      { id: 'PDF_1_3', name: 'PDF 1.3' },
      { id: 'PDFA_1B', name: 'PDF/A-1b' },
      { id: 'PDFA_2B', name: 'PDF/A-2b' },
      { id: 'PDFA_2U', name: 'PDF/A-2u' },
      { id: 'PDFA_3B', name: 'PDF/A-3b' },
      { id: 'PDFA_3U', name: 'PDF/A-3u' },
      { id: 'PDFA_1A', name: 'PDF/A-1a' },
      { id: 'PDFA_2A', name: 'PDF/A-2a' },
      { id: 'PDFA_3A', name: 'PDF/A-3a' }
    ])
    .constant('IMAGE_ROTATION', [
      { id: 'AUTO', name: 'RotateAutomatically' },
      { id: '0', name: '0°' },
      { id: '90', name: '90°' },
      { id: '180', name: '180°' },
      { id: '270', name: '270°' }
    ])
    .constant('MFP_VARIABLES', [
      { id: 'PRINTER_ID',       name: '{printer_id}',       caption: 'PrinterId' },
      { id: 'PRINTER_LOCATION', name: '{printer_location}', caption: 'PrinterLocation' },
      { id: 'PRINTER_NAME',     name: '{printer_name}',     caption: 'PrinterName' },
      { id: 'USER_NAME',        name: '{user_name}',        caption: 'Username' },
      { id: 'WORKFLOW_NAME',    name: '{workflow_name}',    caption: 'WorkflowName' }
    ])
    .constant('PHONE_VARIABLES', [
      { id: 'USER_NAME',     name: '{user_name}',     caption: 'Username' },
      { id: 'WORKFLOW_NAME', name: '{workflow_name}', caption: 'WorkflowName' }
    ])
    .constant('DATE_VARIABLES', [
      { id: 'MM_DD_YYYY',      name: '{mm_dd_yyyy}',      example: '' },
      { id: 'MM_DD_YYYY_TIME', name: '{mm_dd_yyyy_time}', example: '' },
      { id: 'DD_MM_YYYY',      name: '{dd_mm_yyyy}',      example: '' },
      { id: 'DD_MM_YYYY_TIME', name: '{dd_mm_yyyy_time}', example: '' },
      { id: 'YYYY_MM_DD',      name: '{yyyy_mm_dd}',      example: '' },
      { id: 'YYYY_MM_DD_TIME', name: '{yyyy_mm_dd_time}', example: '' }
    ])
    .constant('OUTPUTDOCUMENT_FILETYPE', [
      {
        id: 'OUTPUTDOCUMENT_FILETYPE_PDF_IMAGEONLY',
        name: 'PdfImageOnly',
        fileType: 'GENERATE_SEARCHABLE_PDF',
        isImageOnlyPdf: true
      },
      {
        id: 'OUTPUTDOCUMENT_FILETYPE_PDF_SEARCHABLE',
        name: 'PdfSearchable',
        fileType: 'GENERATE_SEARCHABLE_PDF',
        isImageOnlyPdf: false
      },
      {
        id: 'OUTPUTDOCUMENT_FILETYPE_DOCX',
        name: 'Microsoft Word',
        fileType: 'GENERATE_DOCX'
      }
    ])
    .constant('SEND_TO_USER', [
      { id: 'to', name: 'To' },
      { id: 'cc', name: 'Cc' },
      { id: 'bcc', name: 'Bcc' }
    ]);

})();
